import React from "react";
import MotorcycleDetail from "../components/MotorcycleDetail";

const MotorcycleDetailPage = () => {
  return (
    <div>
      <MotorcycleDetail />
    </div>
  );
};

export default MotorcycleDetailPage;
